/* global axios */
import ApiClient from './ApiClient';

class GgSupportAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  context(conversationId) {
    return axios.get(`${this.url}/${conversationId}/gg_support`);
  }

  tickets(conversationId, { signal }) {
    return axios.get(`${this.url}/${conversationId}/gg_support/tickets`, {
      signal,
    });
  }

  customers(conversationId, query, cursor, { signal, searchBy = 'general' }) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support/customers`,
      { query, cursor, search_by: searchBy },
      { signal }
    );
  }

  customer(conversationId, customerId, { signal }) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support/customers`,
      { customer_id: customerId },
      { signal }
    );
  }

  linkCustomer(conversationId, customerId, { signal }) {
    return axios.put(
      `${this.url}/${conversationId}/gg_support/customer`,
      { customer_id: customerId },
      { signal }
    );
  }

  catalogs(conversationId, criteria, { signal }) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support/catalogs`,
      criteria,
      { signal }
    );
  }

  preview(conversationId, draft) {
    return axios.post(
      `${this.url}/${conversationId}/gg_support/preview`,
      draft
    );
  }

  operation(conversationId, operationId) {
    return axios.get(`${this.url}/${conversationId}/gg_support/operation`, {
      params: { operation_id: operationId },
    });
  }

  confirm(
    conversationId,
    operationId,
    previewDigest,
    description,
    initialStatus = 'Backlog'
  ) {
    return axios.post(`${this.url}/${conversationId}/gg_support/confirm`, {
      operation_id: operationId,
      preview_digest: previewDigest,
      reviewed_description: description,
      reviewed: true,
      ...(initialStatus !== 'Backlog' ? { initial_status: initialStatus } : {}),
    });
  }

  resume(conversationId, operationId) {
    return axios.post(`${this.url}/${conversationId}/gg_support/resume`, {
      operation_id: operationId,
    });
  }
}

export default new GgSupportAPI();
